let active = true;
export function toggleTestId(state) {
  active = state === 'on';
}
function createTestId(component, testId) {
  let caseIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return {
    testId: `${component}:${[...caseIds, testId].join('-')}`
  };
}
export function createDataTestId(testId) {
  return active && testId ? {
    'data-test-id': testId
  } : {};
}
export function getTestId(scope, testId) {
  let caseIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return createTestId(scope, testId, caseIds);
}
export function getDataTestId(scope, testId) {
  let caseIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return createDataTestId(getTestId(scope, testId, caseIds).testId);
}